import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const DARK_CHARCOAL = '#2D2F2D';
const handPattern = `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 5 L35 20 L30 18 L25 20 Z' fill='none' stroke='rgba(255,255,255,0.06)' stroke-width='1'/%3E%3C/svg%3E")`;

/**
 * Centered dark hero banner (Founders / Team style) for inner pages.
 */
const SimplePageBanner = ({ subtitle, title, description, children }) => (
  <>
    <Box
      sx={{
        backgroundColor: DARK_CHARCOAL,
        backgroundImage: handPattern,
        py: { xs: 8, md: 10 },
        px: { xs: 2, sm: 3 },
        textAlign: 'center',
      }}
    >
      <Container maxWidth="md">
        {subtitle ? (
          <Typography
            sx={{
              fontFamily: '"Caveat", cursive',
              fontWeight: 700,
              fontSize: { xs: 28, md: 36 },
              color: 'rgba(255,255,255,0.9)',
              mb: 1,
            }}
          >
            {subtitle}
          </Typography>
        ) : null}
        <Typography
          component="h1"
          sx={{
            fontFamily: '"Nunito", sans-serif',
            fontWeight: 900,
            fontSize: { xs: 36, md: 52 },
            color: '#fff',
            mb: description || children ? 2 : 0,
            lineHeight: 1.15,
          }}
        >
          {title}
        </Typography>
        {description ? (
          <Typography
            sx={{
              fontFamily: '"Poppins", sans-serif',
              fontSize: { xs: 15, md: 17 },
              color: 'rgba(255,255,255,0.78)',
              maxWidth: 560,
              mx: 'auto',
              lineHeight: 1.7,
              mb: children ? 3 : 0,
            }}
          >
            {description}
          </Typography>
        ) : null}
        {children}
      </Container>
    </Box>
    <Box sx={{ height: 4, bgcolor: '#EEECE1' }} />
  </>
);

export default SimplePageBanner;
